<template>
  <div class="account-page statPage">
    <AccountPanel title="Sprzedaż">
      <div class="row">
        <div class="col-md-2">
          <b-form-group label="Data od" description="">
            <b-form-input type="date" v-model="start"/>
          </b-form-group>
        </div>
        <div class="col-md-2">
          <b-form-group label="Data do" description="">
            <b-form-input type="date" v-model="end"/>
          </b-form-group>
        </div>
      </div>
      <div class="row">
        <div class="col-md-12">
          <table class="table table-striped">
            <thead>
            <tr>
              <th class="text-center" scope="col">nr faktury</th>
              <th class="text-center" scope="col">data wystawienia</th>
              <th class="text-center" scope="col">termin płatności</th>
              <th class="text-center" scope="col">status</th>
              <th class="text-center" scope="col">netto</th>
              <th class="text-center" scope="col">brutto</th>

            </tr>
            </thead>
            <tbody>
            <tr v-for="o in this.invoices">
              <td class="text-center">{{ o.number }}</td>
              <td class="text-center">{{ o.added }}</td>
              <td class="text-center">{{ o.payment.substr(0,10) }}</td>
              <td class="text-center">
                <div v-if="!hideInvoiceStatus(o.number, o.price)">
                  <div v-if="status(o.cost) === 'zapłacona'">
                    <b-button
                      class="p-2 w-100 text-center m-0"
                      style="pointer-events: none; display: block;"
                      variant="outline-success"
                    >{{ status(o.cost) }}
                    </b-button>
                  </div>
                  <div v-else-if="status(o.cost) === 'do zapłaty'">
                    <b-button
                      :id="o.number"
                      class="p-2 w-100 text-center m-0"
                      variant="outline-danger"
                      style="display: block"
                    >{{ status(o.cost) }}
                    </b-button>
                  </div>
                </div>
              </td>
              <td class="text-right">{{ formatPrice(o.netto) }}</td>
              <td class="text-right">{{ formatPrice(o.price) }}</td>
            </tr>
            <tr>
              <td colspan="4" class="text-right font-weight-bold">Razem</td>
              <td class="text-right font-weight-bold">{{ formatPrice(invoicesNet) }}</td>
              <td class="text-right font-weight-bold">{{ formatPrice(invoicesGross) }}</td>
            </tr>
            </tbody>

          </table>
        </div>
      </div>

      <div class="row">
        <div class="col-md-12">
          <table class="table table-striped">
            <thead>
            <tr>
              <th class="text-center" scope="col">Nazwa towaru</th>
              <th class="text-center" scope="col">Kod towaru</th>
              <th class="text-center" scope="col">netto [szt.]</th>
              <th class="text-center" scope="col">ilość</th>
              <th class="text-center" scope="col">netto</th>
              <th class="text-center" scope="col">vat</th>
              <th class="text-center" scope="col">brutto</th>
            </tr>
            </thead>
            <tbody>
            <tr v-for="p in this.positions">
              <td class="text-center">{{ p.name }}</td>
              <td class="text-center">{{ p.code }}</td>
              <td class="text-right">{{ formatPrice(p.price) }}</td>
              <td class="text-center">{{ p.quantity }}</td>
              <td class="text-right">{{ formatPrice(p.sumPrice) }}</td>
              <td class="text-right">{{ formatPrice(p.sumTax) }}</td>
              <td class="text-right">{{ formatPrice(p.sumGrossValue) }}</td>
            </tr>
            <tr>
              <td colspan="4" class="text-right font-weight-bold">Razem</td>
              <td class="text-right font-weight-bold">{{ formatPrice(positionsNet) }}</td>
              <td class="text-right font-weight-bold">{{ formatPrice(positionsTax) }}</td>
              <td class="text-right font-weight-bold">{{ formatPrice(positionsGross) }}</td>
            </tr>
            </tbody>

          </table>
        </div>
      </div>


    </AccountPanel>
  </div>
</template>


<script>
  import {mapState} from "vuex";
  import AccountPanel from "./AccountPanel.vue";
  import {BFormGroup} from 'bootstrap-vue/esm/components/form-group/form-group'
  import {BFormInput} from 'bootstrap-vue/esm/components/form-input/form-input'
  import {BTooltip} from "bootstrap-vue/esm/components/tooltip/tooltip";
  import {BButton} from "bootstrap-vue/esm/components/button/button";
  import moment from 'moment'

  export default {
    components: {
      AccountPanel,
      BFormGroup,
      BFormInput,
      BTooltip,
      BButton
    },
    data() {
      return {
        start: null,
        end: null,
        invoices: [],
        invoicesNet: 0,
        invoicesGross: 0,

        positions: [],
        positionsNet: 0,
        positionsTax: 0,
        positionsGross: 0,
      }
    },
    watch: {
      start() {
        this.buildStats();
      },
      end() {
        this.buildStats();
      }
    },

    methods: {
      hideInvoiceStatus(invoiceNumber, invoicePrice) {
        return invoiceNumber.includes("/K") || invoicePrice < 0;
      },
      formatPrice(value) {
        let val = (value / 1).toFixed(2).replace(".", ",");
        return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".");
      },
      status(cost) {
        return cost <= 0 ? "zapłacona" : "do zapłaty";
      },


      async buildStats() {
        if (this.start && this.end) {
          let response = await this.$store.dispatch("company/stats", {start: this.start, end: this.end});
          this.invoices = response.invoices;
          this.invoicesNet = this.invoices.map(i => i.netto).reduce((a, b) =>  a + b);
          this.invoicesGross = this.invoices.map(i => i.price).reduce((a, b) =>  a + b);

          this.positions = [];
          response.positions.forEach(p => {
            let pos = this.positions.find(sp => sp.code === p.code && sp.price == p.price);
            if (pos) {
              pos.quantity += p.quantity;
              pos.sumPrice =  pos.price * pos.quantity;
              pos.sumTax =  pos.tax_value * pos.quantity;
              pos.sumGrossValue =  pos.gross_value * pos.quantity;
            } else {
              p.sumPrice =  p.price * p.quantity;
              p.sumTax =  p.tax_value * p.quantity;
              p.sumGrossValue =  p.gross_value * p.quantity;
              this.positions.push(p);
            }
          });
          this.positionsNet = this.positions.map(i => i.sumPrice).reduce((a, b) =>  a + b);
          this.positionsTax = this.positions.map(i => i.sumTax).reduce((a, b) =>  a + b);
          this.positionsGross = this.positions.map(i => i.sumGrossValue).reduce((a, b) =>  a + b);
        }
      }
    },

    beforeMount() {
      if (!this.$store.state.user.authorizedUser) {
        this.$router.replace({name: 'mainPage'});
      }

      var date = new Date();
      var firstDay = new Date(date.getFullYear(), date.getMonth(), 1);
      var lastDay = new Date(date.getFullYear(), date.getMonth() + 1, 0);

      this.start = moment(firstDay).format('YYYY-MM-DD');
      this.end = moment(lastDay).format('YYYY-MM-DD');
    }

  }
</script>



// WEBPACK FOOTER //
// src/components/account/src/account/SaleStat.vue